/* eslint-disable no-param-reassign, max-params */

import { NECK_LINE_MODES, SURFACES } from "../misc/constants";
import { getDisplayedSize, getSizeWithSteps } from "../utils/sizes";

const DEFAULT_NECK_LABEL = "default";

const initialState = {
  downscaleFactor: 1,
  neckLineMode: NECK_LINE_MODES.DEFAULT,
  customNeckLines: {},
  neckLineLabel: DEFAULT_NECK_LABEL,
  surfaceLabel: SURFACES.FRONT,
  defaultSurface: null
};

const surfaceModule = {
  namespaced: true,

  state() {
    return { ...initialState };
  },

  getters: {
    neckLineMode(state) {
      return state.neckLineMode;
    },
    neckLineLabel(state) {
      return state.neckLineLabel;
    },
    customNeckLines(state) {
      return state.customNeckLines;
    },
    surface(state, _, __, rootGetters) {
      const { surfaces } = rootGetters["product/currentComposition"];
      return surfaces ? surfaces[state.surfaceLabel] : state.defaultSurface;
    },
    downscaleFactor(state) {
      return state.downscaleFactor;
    },
    surfaceLabel(state) {
      return state.surfaceLabel;
    },
    convertPxToInches: (_, getters) => px =>
      getDisplayedSize(px / getters.surface.ppi / getters.downscaleFactor),
    convertInchesToPx: (_, getters) => inches =>
      inches * getters.surface.ppi * getters.downscaleFactor,
    oneInch(state, getters) {
      return getters.surface.ppi * getters.downscaleFactor;
    },
    getSurface: (state, _, __, rootGetters) => label => {
      const { surfaces } = rootGetters["product/currentComposition"];
      return surfaces ? surfaces[label] : state.defaultSurface;
    },
    serializedNeckLines:
      (_, { surfaceLabel, customNeckLines, convertPxToInches, neckLineMode }, __, rootGetters) =>
      artworkHeight => {
        if (neckLineMode === NECK_LINE_MODES.DEFAULT) return {};

        const filledSizes = rootGetters["app/filledSizes"];
        const defaultNeckLines = rootGetters["product/neckLines"][surfaceLabel];
        const allLines = { ...defaultNeckLines, ...customNeckLines };

        return Object.keys(allLines).reduce((acc, key) => {
          if (filledSizes.includes(key)) {
            const maxDistance = getSizeWithSteps(
              defaultNeckLines[key].max_height - convertPxToInches(artworkHeight)
            );
            acc[key] = Math.min(allLines[key].default || allLines[key], maxDistance);
          }
          return acc;
        }, {});
      }
  },

  mutations: {
    setDownscaleFactor(state, downscaleFactor) {
      state.downscaleFactor = downscaleFactor;
    },
    setSurfaceLabel(state, surfaceLabel) {
      state.surfaceLabel = surfaceLabel;
    },
    setDefaultSurface(state, defaultSurface) {
      state.defaultSurface = defaultSurface;
    },
    setNeckLineMode(state, neckLineMode) {
      state.neckLineMode = neckLineMode;
    },
    setNeckLineLabel(state, neckLineLabel) {
      state.neckLineLabel = neckLineLabel || DEFAULT_NECK_LABEL;
    },
    setNeckLineHeight(state, { neckLineLabel, height }) {
      state.customNeckLines = {
        ...state.customNeckLines,
        [neckLineLabel]: height
      };
    }
  },

  actions: {
    clearNeckLines({ commit, state }) {
      commit("setNeckLineMode", NECK_LINE_MODES.DEFAULT);
      commit("setNeckLineLabel", DEFAULT_NECK_LABEL);
      state.customNeckLines = {};
    }
  }
};

export default surfaceModule;
